import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss']
})
export class TextareaInputComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
